// extracted by mini-css-extract-plugin
export default {"container":"Introduction_container__E4yyJ","subcontainer":"Introduction_subcontainer__XnLCR","slider":"Introduction_slider__NjAwH"};